import styled from 'styled-components';
import { Space } from 'antd';

export const ContractFormDescriptionStyled = styled(Space)`
  margin-bottom: 1.25rem;
  width: 100%;

  .contract-form-description-item-label {
    margin-right: 0.3rem;
  }

  .ant-space-item:last-of-type {
    margin-left: auto;
  }
`;
